import React from "react";
import { Feather } from "@expo/vector-icons";
import { color as colorUtil } from "@sloth-system/styled-utils";
import theme from "../../configs/theme-config";

interface PropTypes {
  // TODO:
  // Thesse should be import from @expo/vector-icons
  // but right now there is no way.
  name: any;
  color?: string;
  size?: number;
}

function Icon(props: PropTypes) {
  let { color, ...iconProps } = props;

  if (color) {
    // TODO: this is a hack
    color = colorUtil(color)({ theme: theme });
  }

  return <Feather color={color} {...iconProps} />;
}

export default Icon;
